import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { tap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { EncryptionService } from '../services/encryption.service';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';



@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthService, 
    private router: Router, 
    private encryptionService: EncryptionService,
    private translateService: TranslateService,
    private toastrService: ToastrService,
    ) { }

intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let encryptData:boolean = environment.enableEncryption //To enable/disable encryption

    // add auth header with jwt if user is logged in and request is to the api url
    // const currentUser = this.authenticationService.currentUserValue;
    let authToken = localStorage.getItem(environment.tokenName);
    if (authToken) {
      authToken = authToken.replace(/['"]+/g, '');
      request = request.clone({
        setHeaders: {
          'Authorization': `Bearer ${authToken}`,
          'Accept-Language': localStorage.getItem("lang")!,
        }
      });
    }
    if (!authToken) {
      this.router.navigate(["/auth/login"])
    }

    let req= request

    if (request.body && encryptData) {
      // Encrypt the JSON body
      const encryptedBody = this.encryptionService.encryptBody(request.body);
      // Clone the request and replace the body with the encrypted one
      const clonedRequest = request.clone({
        setHeaders: {
          'Content-Type': 'application/json; charset=utf-8' //For encryption //[IMPORTANT] THIS ENCRYPTION DOES NOT WORK WITH FORMDATA
        },
        body: encryptedBody
      });
      req=clonedRequest;
    }

    return next.handle(req).pipe(
      //For every request check if user does not have persmission will logout
      //(used when changes permission in role which user has so logout to relogin and have the new permission)
      tap(
        event => {
          // if (event instanceof HttpResponse)
          //   console.log('request succeeded');
        },
        error => {
          if (error instanceof HttpErrorResponse) {
            // console.log(error);
            this.errorHandler(error)
          }
        }
    ));
  }

  errorHandler(error:HttpErrorResponse){
    if (error.status === 401) {
      this.authenticationService.logout();
      Swal.fire({
        text: this.translateService.instant('SwalMessages.tokenExpiredMessage'),
        position: 'top-start',
        timer: 4000,
        timerProgressBar: true,
        showConfirmButton: false,
        icon: "info",
      }).then(() => {
        this.router.navigate(["/auth/login"]);
      });
    }else{
      // Can not use the general snackbar service so i had to use it manually here
      this.toastrService.error(error.error.Message ?? this.translateService.instant('ToastMessages.ErrorMsg') ,'',{
        timeOut: 10000,
        positionClass:
         'toast-bottom-left',
      })
    }
  }
}
